import Modal from "~/components/Plugins/Modal.vue";
import mountDynamicComponent from '~/plugins/mountDynamicComponent';

export default defineNuxtPlugin(
    mountDynamicComponent({
        component: Modal,
        functionName: 'showModal'
    })
);
